import React, {useEffect, useState} from "react"
import {useLocation, useNavigate, useSearchParams} from "react-router-dom"
import {
  emptyIftCheckList,
  resetFilterSideBar,
  resetTextFiltersForGroup,
  updateIftCheckList,
  updateSortByValue,
  updateTextFilters,
} from "redux/actions"

import DownArrow from "../../../assets/icons/down-arrow.svg"
import "./filter-sidebar.scss"
import {useSelector, useDispatch} from "react-redux"
import {scrollToTop} from "config/helper"

export const DEPARTMENT_IFT = "category_ids"

const FilterSlidebar = () => {
  const {filterOptions, iftCheckedList} = useSelector(({product}) => product)
  const {departmentTree} = useSelector(s => s.product)
  const dispatch = useDispatch()

  const departmentValues = useDepartmentValues(departmentTree, filterOptions)

  let checkFilters = [],
    valueFilters = []
  filterOptions
    ?.filter(i => i.is_visible === "1")
    ?.forEach(i => {
      if (i?.values?.length) {
        valueFilters.push(i)
      } else {
        checkFilters.push(i)
      }
    })

  valueFilters = valueFilters.sort((a, b) => +a.order_by - +b.order_by)

  const toggleSearchItem = ift => {
    dispatch(updateIftCheckList(ift))
  }

  useEffect(() => {
    scrollToTop()
  }, [filterOptions])

  return (
    <div className="filter-modal">
      <div className="filter-header"></div>
      <Filters
        checkFilters={checkFilters}
        iftCheckedList={iftCheckedList}
        toggleSearchItem={toggleSearchItem}
      />
      <div className="accordion">
        <SearchGroup key="department-filter-list" data={departmentValues} />
      </div>
      <div className="accordion">
        {valueFilters.map((i, idx) => {
          const key = `${i.ift_id}-${idx}-${i.title}-${i.ift}`
          return <SearchGroup key={key} data={i} />
        })}
      </div>
    </div>
  )
}

function Filters({checkFilters, iftCheckedList, toggleSearchItem}) {
  const [open, setOpen] = useState(false)
  const [searchParams] = useSearchParams();
  const {filterOptions} = useSelector(({product}) => product)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const showClear = iftCheckedList?.length > 0

  useEffect(() => {
    // if user selects a department from "Shop by department" then auto select that department
    const departmentId = searchParams.get("category_ids");
    const ebt_ift = searchParams.get("ift"); // for ebt elibigle item link in my account page
    if (location.pathname === "/search/products/") {
      let weeklyAdsIft
      if (departmentId === "-1") {
        // -1 is weekly ads
        weeklyAdsIft = filterOptions?.filter(i => i.is_visible === "1")?.find(i => i?.title?.toLowerCase()?.includes("weekly"))?.ift
      }
      if (weeklyAdsIft || ebt_ift) {
        // Use setTimeout to ensure resetFilterSideBar completes before updateIftCheckList
        dispatch(resetFilterSideBar());
        setTimeout(() => {
          dispatch(updateIftCheckList(weeklyAdsIft || ebt_ift, true));
          setOpen(true);
          navigate(`/search/products/`);
        }, 0);
      }
    }
  }, [searchParams, location.pathname, dispatch, navigate, filterOptions])

  const handleClearClick = (e) => {
    e.stopPropagation()
    dispatch(emptyIftCheckList())
  }

  return (
    <div className="filters">
      <div className="filters-header" onClick={() => setOpen(!open)}>
        Filters
        <div>
        {showClear && <button onClick={handleClearClick} >Clear</button>}
         <img src={DownArrow} alt="arrow icon" className={`arrow-icon ${open ? "rotate" : ""}`} />
        </div>
      </div>
      <div className={open ? "dropdown-show" : "dropdown-hidden"}>
        <div className="filter-items">
          {checkFilters.map((i, idx) => (
            <div key={`${i.ift}-${idx}`}>
              <input
                type="checkbox"
                id={i.ift}
                onChange={() => toggleSearchItem(i.ift)}
                checked={iftCheckedList.includes(i.ift)}
              />
              <label className="checkbox" htmlFor={i.ift}>
                <span>
                  {i.title} {+i.count > 0 ? `(${i.count})` : null}
                </span>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const SearchGroup = ({data}) => {
  const [open, setOpen] = useState(true)
  const [search, setSearch] = useState("")
  const dispatch = useDispatch()
  const [showSearch, setShowSearch] = useState(false)
  const {textFilters} = useSelector(({product}) => product)
  const {departmentTree} = useSelector(s => s.product)
  const [showClearAll, setShowClearAll] = useState(false)

  const departments = Boolean(data?.isDepartments)

  const handleClearAllClick = (e) => {
    e.stopPropagation()

    const isDepartmentFilter =
    departments ||
    data.isDepartments ||
    data.ift === DEPARTMENT_IFT ||
    data.title === "Departments"

    let key = isDepartmentFilter ? DEPARTMENT_IFT : data.ift
    dispatch(resetTextFiltersForGroup(key))
    setShowClearAll(false)
  }

  useEffect(() => {
    const isDepartmentFilter =
      departments ||
      data.isDepartments ||
      data.ift === DEPARTMENT_IFT ||
      data.title === "Departments"

    if (isDepartmentFilter) {
      setShowClearAll(textFilters[DEPARTMENT_IFT]?.length > 0)
    } else {
      setShowClearAll(textFilters[data.ift]?.length > 0)
    }
  }, [data.ift, data.isDepartments, data.title, departments, textFilters])

  const options = data?.options || []
  const values = data?.values
    ?.filter(opt => {
      if (typeof opt !== "string") return false

      const text = opt.toLowerCase().replace(/ /g, "")
      const searchText = search.toLowerCase().replace(/ /g, "")
      return text.includes(searchText)
    })
    .sort((a, b) => {
      const aText = a.toLowerCase().replace(/ /g, "")
      const bText = b.toLowerCase().replace(/ /g, "")
      const searchText = search.toLowerCase().replace(/ /g, "")

      const aStartsWith = aText.startsWith(searchText)
      const bStartsWith = bText.startsWith(searchText)

      if (aStartsWith && !bStartsWith) return -1
      if (!aStartsWith && bStartsWith) return 1
      return a.localeCompare(b)
    })

  useEffect(() => {
    if (data?.values?.length > 8) {
      setShowSearch(true)
    } else {
      setShowSearch(false)
      setSearch("")
    }
  }, [data?.values])

  function getCount(opt) {
    const count =
      options.find(o => o.value === opt || o.name === opt)?.count || 0
    return +count > 0 ? `(${count})` : null
  }

  function isChecked(opt) {
    // Check if this is a department filter by multiple criteria
    const isDepartmentFilter =
      departments ||
      data.isDepartments ||
      data.ift === DEPARTMENT_IFT ||
      data.title === "Departments"

    if (isDepartmentFilter) {
      const {category_ids} = departmentTree.find(o => o.name === opt) ?? {}
      return textFilters[DEPARTMENT_IFT]?.includes(category_ids) || false
    }
    return textFilters[data.ift]?.includes(opt) || false
  }

  function handleOnChange(opt) {
    const isDepartmentFilter =
      departments ||
      data.isDepartments ||
      data.ift === DEPARTMENT_IFT ||
      data.title === "Departments"
    if (isDepartmentFilter) {
      const {category_ids} = departmentTree.find(o => o.name === opt) ?? {}
      dispatch(updateSortByValue(""))
      dispatch(updateTextFilters({category: DEPARTMENT_IFT, value: category_ids}))
    } else {
      dispatch(updateTextFilters({category: data.ift, value: opt}))
    }
  }

  if (!values?.length && !search) {
    return null
  }

  return (
    <div className="accordion-item" key={`${data.ift_id}-${data.title}`}>
      <button className="accordion-header" onClick={() => setOpen(!open)}>
        {data.title}
        <div>
        {showClearAll && (
           <button onClick={handleClearAllClick}>Clear</button>
         )}
        <img src={DownArrow} alt="arrow icon" className={`arrow-icon ${open ? "rotate" : ""}`} />
        </div>
      </button>
      <div className={open ? "dropdown-show" : "dropdown-hidden"}>
        {showSearch ? (
          <div className="search-container">
            <input
              type="text"
              className="search-input"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder=""
            />
          </div>
        ) : null}
        <ul className="submenu">
          {values?.map(opt => {
            return (
              <li key={`${data.title}-${opt}-${data.ift_id}`}>
                <input
                  type="checkbox"
                  id={`${data.ift_id}-${opt}`}
                  checked={isChecked(opt)}
                  onChange={() => handleOnChange(opt)}
                />
                <label htmlFor={`${data.ift_id}-${opt}`} className="checkbox">
                  <span>
                    {opt} {getCount(opt)}
                  </span>
                </label>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

// modify data to match with other filter data, so we can render department list normally like other filters
function useDepartmentValues(departmentTree, filterOptions) {
  // TODO may be remove in future
  // Below code is commented to always show all the departments

  // const {textFilters, iftCheckedList} = useSelector(({product}) => product)
  // const {searchText} = useSelector(({search}) => search)
  let values = departmentTree.map(d => d.name)

  // const noTextSearch = Boolean(!searchText?.trim()?.length)
  // const haveSelectedDepartments = textFilters[DEPARTMENT_IFT]?.length > 0
  
  const deptFilterOption = filterOptions?.find(
    i => i.ift === "department_number"
  )
  
  // const isTextSearch = !noTextSearch
  // const otherFiltesAvailable =
  // Object.entries(
  //   (key, value) => key !== DEPARTMENT_IFT && value?.length > 0
  // ).some(i => i?.length > 0) || iftCheckedList?.length > 0

  // const doFiltersDepartments = isTextSearch
  // if (doFiltersDepartments && Array.isArray(deptFilterOption?.options)) {
  //   // in case of text search or other filter search, hide departments without items
  //   const filtereDeptIds = deptFilterOption?.options?.map(d => d?.value)
  //   values = departmentTree
  //     ?.filter(
  //       d =>
  //         filtereDeptIds?.includes(d?.department_no) ||
  //         textFilters[DEPARTMENT_IFT]?.includes(d?.category_ids)
  //     )
  //     ?.map(d => d?.name)
  //   }

  if (!deptFilterOption) {
    return {}
  }
  
  // const hideItemCount = noTextSearch && (haveSelectedDepartments || otherFiltesAvailable)
  // const options = hideItemCount ? [] : [...deptFilterOption.options]?.map(i => {
  const options = [...deptFilterOption.options]?.map(i => {
    const dept = departmentTree?.find(d => d.department_no === i.value)
    return {
      ...i,
      name: dept?.name,
      value: dept?.category_ids,
      slug: dept?.slug,
    }
  })

  return {
    ift_id: "99",
    title: "Departments",
    ift: DEPARTMENT_IFT,
    is_visible: "1",
    values,
    options,
    order_by: "1",
    isDepartments: true,
  }
}

export default FilterSlidebar
